export const useSetupLocalNotifications = (): null => {
  return null;
};
